import React from 'react';

const Icon: React.FunctionComponent<{ passesCheck: boolean }> = (props) => {
    if (props.passesCheck === true) {
        return (
            <svg className="icon icon--tick">
                <use xlinkHref="#icon-tick" />
            </svg>
        );
    } else {
        return (
            <svg className="icon icon--close">
                <use xlinkHref="#icon-close" />
            </svg>
        );
    }
};

export default Icon;
